/**
 * 画像モーダル
 */

const zoomModalSpMedia = '(width < 768px)'

export function zoomModal() {
	const zoomModalMediaQuery = window.matchMedia(zoomModalSpMedia)

	const zoomModalEl = document.querySelector('.js-zoom-modal')
	const zoomModalContEl = document.querySelector('.js-zoom-modal-cont')

	if (!zoomModalEl || !zoomModalContEl) return

	const zoomModalOriginalParent = zoomModalEl.parentNode

	function zoomModalOpen(trigger) {
		zoomModalContEl.innerHTML = ''
		const zoomModalContent = trigger.innerHTML.trim()
		if (zoomModalContent) {
			zoomModalContEl.insertAdjacentHTML('afterbegin', zoomModalContent)
		}
		zoomModalContEl.style.transform = ''
		document.body.appendChild(zoomModalEl)
		zoomModalEl.classList.add('is-open')
		document.documentElement.style.overflow = 'hidden'
		document.body.style.overflow = 'hidden'
	}

	function zoomModalClose() {
		zoomModalEl.classList.remove('is-open')
		document.documentElement.style.overflow = ''
		document.body.style.overflow = ''
		if (zoomModalOriginalParent) {
			zoomModalOriginalParent.appendChild(zoomModalEl)
		}
	}

	function zoomModalOnTriggerClick(e) {
		e.preventDefault()
		const zoomModalTrigger = e.currentTarget
		zoomModalOpen(zoomModalTrigger)
	}

	function zoomModalOnCloseClick(e) {
		e.preventDefault()
		zoomModalClose()
	}

	function zoomModalOnInnerClick(e) {
		e.stopPropagation()
	}

	function zoomModalAttachListeners() {
		const zoomModalTriggers = document.querySelectorAll(
			'.js-zoom-modal-trigger',
		)
		const zoomModalCloseTargets = document.querySelectorAll(
			'.js-zoom-modal-close',
		)
		const zoomModalInnerEl = document.querySelector('.p-zoom-modal')

		zoomModalTriggers.forEach((zoomModalTrigger) => {
			zoomModalTrigger.addEventListener('click', zoomModalOnTriggerClick)
		})

		zoomModalCloseTargets.forEach((zoomModalCloseTarget) => {
			zoomModalCloseTarget.addEventListener('click', zoomModalOnCloseClick)
		})

		if (zoomModalInnerEl) {
			zoomModalInnerEl.addEventListener('click', zoomModalOnInnerClick)
		}
	}

	function zoomModalDetachListeners() {
		const zoomModalTriggers = document.querySelectorAll(
			'.js-zoom-modal-trigger',
		)
		const zoomModalCloseTargets = document.querySelectorAll(
			'.js-zoom-modal-close',
		)
		const zoomModalInnerEl = document.querySelector('.p-zoom-modal')

		zoomModalTriggers.forEach((zoomModalTrigger) => {
			zoomModalTrigger.removeEventListener('click', zoomModalOnTriggerClick)
		})

		zoomModalCloseTargets.forEach((zoomModalCloseTarget) => {
			zoomModalCloseTarget.removeEventListener('click', zoomModalOnCloseClick)
		})

		if (zoomModalInnerEl) {
			zoomModalInnerEl.removeEventListener('click', zoomModalOnInnerClick)
		}

		document.documentElement.style.overflow = ''
		document.body.style.overflow = ''
		zoomModalClose()
	}

	function zoomModalHandleMediaChange(mq) {
		if (mq.matches) {
			zoomModalAttachListeners()
		} else {
			zoomModalDetachListeners()
		}
	}

	if (zoomModalMediaQuery.matches) {
		zoomModalAttachListeners()
	}
	zoomModalMediaQuery.addEventListener('change', zoomModalHandleMediaChange)
}
